import React, { useState } from "react";

const FAQSection = () => {
  const [activeTab, setActiveTab] = useState("tab_general_question");
  const [activeAccordion, setActiveAccordion] = useState("collapse_1");

  const toggleTab = (tabId) => {
    setActiveTab(tabId);
  };

  const toggleAccordion = (accordionId) => {
    setActiveAccordion(accordionId === activeAccordion ? "" : accordionId);
  };

  // Array of FAQ questions
  const faqQuestions = [
    {
      question: "How do I earn TopCoin UK units?",
      answer:
        "You automatically receive units when you purchase from any participating business. These units are completely free and rewarded based on your purchase.",
    },
    {
      question: "Do I have to invest money to get units?",
      answer: (
        <ul>
          <li>
            TopCoin UK is not an investment service. We do not sell coins,
            accept customer funds, or offer financial products. All units are
            free and given as loyalty rewards. FCA regulation does not apply.
          </li>
          <li>
            Because TopCoin UK is not a form of gambling or financial trading,
            people under 18 are also allowed to receive and benefit from units.
          </li>
        </ul>
      ),
    },
    {
      question: "Can I use my units to buy things?",
      answer:
        "TopCoin UK units unlock cash rewards from company wallets. In the future, units may also unlock discounts or exclusive offers, but they are not a currency.",
    },
    // {
    //   question: "Disclaimer",
    //   answer:
    //     "TopCoin UK units unlock cash rewards from company wallets. In the future, units may also unlock discounts or exclusive offers — but they are not a currency.",
    // },
  ];
  const icoQuestions = [
    {
      question: "What is TopCoin?",
      answer:
        "TopCoin UK is a loyalty and advertising reward system. Customers receive free TopCoin UK units when they buy products from participating businesses. These units are stored in their personal Customer Units Wallets.",
    },
    {
      question: "Is TopCoin UK a cryptocurrency or investment product?",
      answer:
        "No. TopCoin UK is not a cryptocurrency or investment scheme. The units are loyalty rewards, not financial instruments, and cannot be traded or speculated on.",
    },
    // {
    //   question: "Can anyone collect TopCoin UK units?",
    //   answer:
    //     "Yes. Because TopCoin UK is not a cryptocurrency, financial product, or gambling system, people under the age of 18 can also receive units. It's a family-friendly loyalty system, and everyone is welcome to be part of the TopCoin UK community.",
    // },
    // "What is the TopCoin?",
    // "How do I register for the TopCoin?",
    // "What is the CoinLye token?",
    // "How can I purchase CoinLye tokens?",
    // "What are the tokenomics of CoinLye tokens?",
  ];

  // Array of Token Sales questions
  const tokenSalesQuestions = [
    {
      question: "What are Customer Units Wallets and Company Cash Wallets?",
      answer:
        "TopCoin UK has six Customer Units Wallets where your earned units are stored. As you collect more units, you unlock additional wallets with higher rewards. There are also five Company Cash Wallets. These contain cash rewards, released to you when you unlock milestones. Both unit and cash rewards belong to the customer.",
    },
    {
      question: "Why do TopCoin UK units increase in value?",
      answer:
        "As you earn more units and unlock new wallets, you access larger cash rewards. This value increase is based on loyalty, not on investment, trading, or speculation.",
    },
  ];

  // Array of Clients Related questions
  const clientsRelatedQuestions = [
    {
      question: "Does TopCoin UK need FCA regulation?",
      answer: (
        <ul>
          <li>
            No. TopCoin UK does not require regulation by the Financial Conduct
            Authority (FCA) because we do not offer financial services, handle
            customer funds, or promote investment opportunities.
          </li>
          <li>
            Our platform is structured entirely around free loyalty rewards
            given at the point of purchase. Customers never invest, deposit
            money, or buy financial assets of any kind.
          </li>
          <li>
            TopCoin UK units are not tradable, not speculative, and are not tied
            to financial markets. They are earned through real purchases and act
            as a unique reward mechanism.
          </li>
          <li>
            Since we operate as a marketing and promotional service, not a
            financial one, FCA regulation does not apply.
          </li>
        </ul>
      ),
    },
  ];
  // Array of Busniess  Related questions
  const busniessRelatedQuestions = [
    {
      question: "How do shops or businesses join?",
      answer: (
        <ul>
          <li>
            Businesses can join the TopCoin UK network by subscribing to our
            promotional system. When customers shop with you, they receive free
            TopCoin UK units, giving them a reason to return and spend more.
          </li>
          <li>
            TopCoin UK helps boost product sales, attract new customers, and
            build brand loyalty. It's a new-generation platform designed to
            benefit both businesses and consumers.
          </li>
          <li>
            Each new business that joins creates its own TopCoin blockchain,
            meaning your activity, growth, and rewards are uniquely tracked and
            rewarded.
          </li>
          <li>This is a win-win system for both customers and businesses.</li>
        </ul>
      ),
    },
    {
      question: "Why join TopCoin UK?",
      answer: (
        <ul className="list-unstyled">
          <li>- Attract more customers with a reward system they understand</li>
          <li>
            - Encourage repeat purchases through milestone-based wallet rewards
          </li>
          <li>- Gain visibility through the broader TopCoin UK network</li>
          <li>
            - Offer more value than competitors with no extra cost to the
            customer
          </li>
          <li>
            - Be part of the latest marketing innovation using
            blockchain-inspired systems
          </li>
        </ul>
      ),
    },

    {
      question: "Ready to Grow Your Sales and Stand Out?",
      answer: (
        <div>
          <p className="mb-1">
            At Topcoin UK, we help forward,thinking businesses increase their
            visibility, attract loyal customers, and stand out ,all through a
            unique and powerful reward system.
          </p>

          <p className="mb-3">
            When customers shop with you, they receive free Topcoin UK units,
            which unlock real cash rewards as they progress. Every unit is a
            thank-you for their loyalty ,and a reason to return.
          </p>

          <h5 className="fw-medium text-dark-emphasis">But this isn’t just about rewarding customers.</h5>

          <p className="mb-1">
            It’s about helping your business grow, get noticed, and become part
            of something bigger.
          </p>
          <ul className="list-unstyled">
            <li>
              - More Visibility Be featured on the Topcoin UK platform and
              attract new customers from across the network.
            </li>
            <li>
              - Stronger Customer Loyalty Every customer who shops with you is
              rewarded instantly, creating lasting loyalty and stronger
              relationships.
            </li>
            <li>
              - Network Growth Benefits Once you’re part of the Topcoin UK
              network, your business grows as customers shop across other
              participating businesses too ,not just yours.
            </li>
            <li>
              - Blockchain-Backed Reputation Your shop or company gets its own
              blockchain profile within the Topcoin UK system ,increasing
              credibility and transparency.{" "}
            </li>
          </ul>
          <h5 className="fw-medium text-dark-emphasis">Real Growth, Real Results</h5>
          <p className="mb-1">Customers love to be rewarded. Topcoin UK helps your business:</p>
          <ul className="list-unstyled">
            <li>-Build lasting loyalty</li>
            <li>- Attract new customers</li>
            <li>- Strengthen your brand reputation</li>
            <li>- Become part of a growing national reward movement</li>
          </ul>
          <h5 className="fw-medium text-dark-emphasis"> Join the Movement</h5>
          <ul className="list-unstyled">
            <li>
              If you’re ready to grow your sales, build trust, and stand out
              ,Topcoin UK is your next step forward.
            </li>
            <li>
              Reward your customers. Grow your network. Strengthen your brand.
            </li>
            <li>Be part of something that gives back.</li>
          </ul>
        </div>
      ),
    },
  ];

  // Array of Careers  Related questions
  const careersRelatedQuestions = [
    {
      question: "Can I work with TopCoin UK as a promoter or agent?",
      answer: (
        <ul>
          <li>
            We welcome self-employed individuals who want to promote TopCoin UK
            or help expand our business network.
          </li>
          <li>
            If you're interested in working with us, visit our Join Our Team
            page to learn more and apply.
          </li>
        </ul>
      ),
    },
  ];
  // Array of Careers  Related questions
  // const careersDisclaimerQuestions = [
  //   {
  //     question: "Can I work with TopCoin UK as a promoter or agent?",
  //     answer: (
  //       <ul>
  //         <li>
  //           We welcome self-employed individuals who want to promote TopCoin UK
  //           or help expand our business network.
  //         </li>
  //         <li>
  //           If you're interested in working with us, visit our Join Our Team
  //           page to learn more and apply.
  //         </li>
  //       </ul>
  //     ),
  //   },
  // ];

  return (
    <section
      className="faq_section bg-light-subtle section_space"
      id="id_faq_section"
    >
      <div className="container">
        <div
          className="ico_heading_block text-center"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <h2 className="heading_text text-dark mb-0">
            Frequently Asked Questions
          </h2>
        </div>

        <div
          className="tab_block"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="100"
        >
          <div className="d-flex justify-content-center">
            <ul
              className="nav unordered_list justify-content-md-center"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "tab_ico_questions" ? "active" : ""
                  }`}
                  type="button"
                  role="tab"
                  onClick={() => toggleTab("tab_ico_questions")}
                >
                  TopCoin Questions
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "tab_general_question" ? "active" : ""
                  }`}
                  type="button"
                  role="tab"
                  onClick={() => toggleTab("tab_general_question")}
                >
                  Earning & Using TopCoin UK Units
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "tab_tokens_sales" ? "active" : ""
                  }`}
                  type="button"
                  role="tab"
                  onClick={() => toggleTab("tab_tokens_sales")}
                >
                  The Wallet System
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "tab_clients_releted" ? "active" : ""
                  }`}
                  type="button"
                  role="tab"
                  onClick={() => toggleTab("tab_clients_releted")}
                >
                  Compliance & Regulation
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "tab_business_releted" ? "active" : ""
                  }`}
                  type="button"
                  role="tab"
                  onClick={() => toggleTab("tab_business_releted")}
                >
                  For Businesses
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "tab_careers_releted" ? "active" : ""
                  }`}
                  type="button"
                  role="tab"
                  onClick={() => toggleTab("tab_careers_releted")}
                >
                  Careers
                </button>
              </li>
            </ul>
          </div>

          <div className="tab-content">
            {/* General Question Tab */}
            <div
              className={`tab-pane fade ${
                activeTab === "tab_general_question" ? "show active" : ""
              }`}
              role="tabpanel"
              id="tab_general_question"
            >
              <div className="ico_accordion" id="accordion_1">
                {faqQuestions.map((item, index) => {
                  const collapseId = `collapse_${index + 1}`;
                  return (
                    <div className="accordion-item" key={collapseId}>
                      <div
                        className={`icon_arrow ${
                          activeAccordion === collapseId ? "collapsed" : ""
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        <svg
                          viewBox="0 0 23 27"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                          <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                          <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                        </svg>
                      </div>
                      <div
                        className={`accordion-button ${
                          activeAccordion === collapseId ? "" : "collapsed"
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        {`${index + 1}- ${item.question}`}
                      </div>
                      <div
                        id={collapseId}
                        className={`accordion-collapse collapse ${
                          activeAccordion === collapseId ? "show" : ""
                        }`}
                        data-bs-parent="#accordion_1"
                      >
                        <div className="accordion-body">
                          <p>
                            <p>{item.answer}</p>
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* ICO Questions Tab */}
            <div
              className={`tab-pane fade ${
                activeTab === "tab_ico_questions" ? "show active" : ""
              }`}
              role="tabpanel"
              id="tab_ico_questions"
            >
              <div className="ico_accordion" id="accordion_2">
                {icoQuestions.map((item, index) => {
                  const collapseId = `collapse_ico_${index + 1}`;
                  return (
                    <div className="accordion-item" key={collapseId}>
                      <div
                        className={`icon_arrow ${
                          activeAccordion === collapseId ? "collapsed" : ""
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        <svg
                          viewBox="0 0 23 27"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                          <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                          <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                        </svg>
                      </div>
                      <div
                        className={`accordion-button ${
                          activeAccordion === collapseId ? "" : "collapsed"
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        {`${index + 1}- ${item.question}`}
                      </div>
                      <div
                        id={collapseId}
                        className={`accordion-collapse collapse ${
                          activeAccordion === collapseId ? "show" : ""
                        }`}
                        data-bs-parent="#accordion_2"
                      >
                        <div className="accordion-body">
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Tokens Sales Tab */}
            <div
              className={`tab-pane fade ${
                activeTab === "tab_tokens_sales" ? "show active" : ""
              }`}
              role="tabpanel"
              id="tab_tokens_sales"
            >
              <div className="ico_accordion" id="accordion_3">
                {tokenSalesQuestions.map((item, index) => {
                  const collapseId = `collapse_token_sales_${index + 1}`;
                  return (
                    <div className="accordion-item" key={collapseId}>
                      <div
                        className={`icon_arrow ${
                          activeAccordion === collapseId ? "collapsed" : ""
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        <svg
                          viewBox="0 0 23 27"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                          <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                          <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                        </svg>
                      </div>
                      <div
                        className={`accordion-button ${
                          activeAccordion === collapseId ? "" : "collapsed"
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        {`${index + 1}- ${item.question}`}
                      </div>
                      <div
                        id={collapseId}
                        className={`accordion-collapse collapse ${
                          activeAccordion === collapseId ? "show" : ""
                        }`}
                        data-bs-parent="#accordion_3"
                      >
                        <div className="accordion-body">
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Clients Related Tab */}
            <div
              className={`tab-pane fade ${
                activeTab === "tab_clients_releted" ? "show active" : ""
              }`}
              role="tabpanel"
              id="tab_clients_releted"
            >
              <div className="ico_accordion" id="accordion_4">
                {clientsRelatedQuestions.map((item, index) => {
                  const collapseId = `collapse_clients_${index + 1}`;
                  return (
                    <div className="accordion-item" key={collapseId}>
                      <div
                        className={`icon_arrow ${
                          activeAccordion === collapseId ? "collapsed" : ""
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        <svg
                          viewBox="0 0 23 27"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                          <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                          <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                        </svg>
                      </div>
                      <div
                        className={`accordion-button ${
                          activeAccordion === collapseId ? "" : "collapsed"
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        {`${index + 1}- ${item.question}`}
                      </div>
                      <div
                        id={collapseId}
                        className={`accordion-collapse collapse ${
                          activeAccordion === collapseId ? "show" : ""
                        }`}
                        data-bs-parent="#accordion_4"
                      >
                        <div className="accordion-body">
                          <p>{item.answer}</p>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Business Related Tab */}

            <div
              className={`tab-pane fade ${
                activeTab === "tab_business_releted" ? "show active" : ""
              }`}
              role="tabpanel"
              id="tab_business_releted"
            >
              <div className="ico_accordion" id="accordion_4">
                {busniessRelatedQuestions.map((item, index) => {
                  const collapseId = `collapse_business_${index + 1}`;
                  return (
                    <div className="accordion-item" key={collapseId}>
                      <div
                        className={`icon_arrow ${
                          activeAccordion === collapseId ? "collapsed" : ""
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        <svg
                          viewBox="0 0 23 27"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                          <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                          <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                        </svg>
                      </div>
                      <div
                        className={`accordion-button ${
                          activeAccordion === collapseId ? "" : "collapsed"
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        {`${index + 1}- ${item.question}`}
                      </div>
                      <div
                        id={collapseId}
                        className={`accordion-collapse collapse ${
                          activeAccordion === collapseId ? "show" : ""
                        }`}
                        data-bs-parent="#accordion_4"
                      >
                        <div className="accordion-body">
                          <p>{item.answer}</p>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* careers Related Tab */}

            <div
              className={`tab-pane fade ${
                activeTab === "tab_careers_releted" ? "show active" : ""
              }`}
              role="tabpanel"
              id="tab_careers_releted"
            >
              <div className="ico_accordion" id="accordion_4">
                {careersRelatedQuestions.map((item, index) => {
                  const collapseId = `collapse_careers_${index + 1}`;
                  return (
                    <div className="accordion-item" key={collapseId}>
                      <div
                        className={`icon_arrow ${
                          activeAccordion === collapseId ? "collapsed" : ""
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        <svg
                          viewBox="0 0 23 27"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                          <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                          <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                        </svg>
                      </div>
                      <div
                        className={`accordion-button ${
                          activeAccordion === collapseId ? "" : "collapsed"
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        {`${index + 1}- ${item.question}`}
                      </div>
                      <div
                        id={collapseId}
                        className={`accordion-collapse collapse ${
                          activeAccordion === collapseId ? "show" : ""
                        }`}
                        data-bs-parent="#accordion_4"
                      >
                        <div className="accordion-body">
                          <p>{item.answer}</p>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* careers Disclaimer Tab */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
